import React from "react";
import * as CONFIG from "../redux_store/configState";
import { createConditionFunction } from "../redux_store/warningHelper";

const PURLIN_OPTION_WARNING =
    "⚠️ Purlin options different in Areas (Purlins Inset | Purlins On Top). Proceed with caution.";

const MULTI_PURLIN_INSULATED_WARNING =
    "⚠️ Insulated Panels cannot have multiple Purlins in a single Area. Roofsheet Span too Large, change size or roofsheet.";

const NIGHT_SKY_COLOUR_WARNING =
    "⚠️ DUE TO TEMPORARY SUPPLY ISSUES WITH NIGHT SKY COIL, THIS COLOUR OPTION IS UNAVAILABLE, PLEASE CHANGE THE SELECTION PRIOR TO ORDER. FOR FURTHER INFORMATION PLEASE CONTACT THE FIELDERS SA OFFICE.";

const OLDER_ATTACH_METHOD_WARNING =
    "⚠️ This job is using an older attachment definition method. Consider upgrading in the 'Attachment/House' menu.";

const BONDOR_MASONRY_MIN_BRICKWORK =
    "⚠️ A minimum of 1500mm of brickwork above the attachment point is required for Bondor Products.";

const hasDifferentRidgeBeamValues = (areaSpecifications) => {
    if (!areaSpecifications || areaSpecifications.length === 0) {
        return false; // or return an appropriate default value based on your requirements
    }

    const ridgeBeamValues = new Set();

    for (const areaSpec of areaSpecifications) {
        const hasRidgeBeam = areaSpec.BEAMS_AND_POSTS?.HasRidgeBeam;
        if (hasRidgeBeam !== undefined) {
            ridgeBeamValues.add(hasRidgeBeam);
        }
    }

    return ridgeBeamValues.size > 1;
};

const handleWarning = (props, warningMessages, setWarningMessages, condition, warning) => {
    if (condition(props)) {
        if (!warningMessages.includes(warning)) {
            setWarningMessages([...warningMessages, warning]);
        }
    } else {
        if (warningMessages.includes(warning)) {
            setWarningMessages(warningMessages.filter((message) => message !== warning));
        }
    }
};

const purlinWarningCondition = (props) => props?.job?.id && hasDifferentRidgeBeamValues(props?.job?.AreaSpecifications);

const insulatedPurlinWarningCondition = (props) => {
    return (props?.job?.AreaSpecifications || []).some((thisArea) => {
        const isFlat = thisArea?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.FLAT;
        const EngineeringResults = props?.job?.QuoteParameters?.ENGINEERING?.EngineeringResults;

        return (
            isFlat &&
            thisArea?.ROOF_SHEETING?.RoofSheetData?.InsulatedOverspan &&
            thisArea?.ROOF_SHEETING?.RoofSheetData?.PressureTableMaxSpanSingle &&
            EngineeringResults
        );
    });
};

const nightSkyWarningConidtion = (props) => {
    return (props?.job?.AreaSpecifications || []).some((thisArea) => {
        const brand = props?.job?.Distributor?.Brand;

        return (
            brand === "Fielders" &&
            (thisArea?.BEAMS_AND_POSTS?.BeamCol1 === "Night Sky" ||
                thisArea?.BEAMS_AND_POSTS?.BeamCol2 === "Night Sky" ||
                thisArea?.BEAMS_AND_POSTS?.BeamCol3 === "Night Sky" ||
                thisArea?.BEAMS_AND_POSTS?.BeamCol4 === "Night Sky") &&
            props?.job?.Distributor?.Address.State === "SA"
        );
    });
};

const attachmentMethodWarningCondition = (props) => props?.job && !props?.job?.DesignParameters?.USE_ATTACHMENTS_2;

export const brickworkBondorHeightCondition = (props) => {
    return (
        props?.job &&
        props.job.AreaSpecifications?.some((area) => {
            const roofSheeting = area?.ROOF_SHEETING;
            const attachments = area?.ATTACHMENTS?.AttachmentModifications;

            return (
                roofSheeting?.RoofGroupType?.toLowerCase().includes("bondor") &&
                attachments?.some &&
                attachments?.some((attachment) => attachment?.AttachmentVariation?.toLowerCase().includes("masonry"))
            );
        })
    );
};

export const brickworkBondorHeightConditionIndex = (props) => {
    const areaIndex = props?.job?.AreaSpecifications?.findIndex((area) => {
        const roofSheeting = area?.ROOF_SHEETING;
        const attachments = area?.ATTACHMENTS?.AttachmentModifications;

        return (
            roofSheeting?.RoofGroupType?.toLowerCase().includes("bondor") &&
            attachments?.some((attachment) => attachment?.AttachmentVariation?.toLowerCase().includes("masonry"))
        );
    });

    return areaIndex;
};

// TODO: Move conditions to config for admin handling. Eventually moving all warnings and warning messages to admin control
const DesignerDrawingWarnings = ({ props, warningMessages, setWarningMessages, config }) => {
    React.useEffect(() => {
        let conditionsToCheck = [
            // { condition: purlinWarningCondition, warningType: PURLIN_OPTION_WARNING },
            { condition: insulatedPurlinWarningCondition, warningType: MULTI_PURLIN_INSULATED_WARNING },
            { condition: nightSkyWarningConidtion, warningType: NIGHT_SKY_COLOUR_WARNING },
            { condition: attachmentMethodWarningCondition, warningType: OLDER_ATTACH_METHOD_WARNING },

            // { condition: brickworkBondorHeightCondition, warningType: BONDOR_MASONRY_MIN_BRICKWORK },
        ];

        const allWarnings = config?.all_warnings;
        if (allWarnings?.jobWarning) {
            console.log(allWarnings?.jobWarning);
            const warning = allWarnings?.jobWarning;

            for (const type in warning) {
                if (warning.hasOwnProperty(type) && type !== "info") {
                    const conditionStrings = warning[type]?.conditions;
                    const condition = createConditionFunction(conditionStrings);
                    const message = warning[type]?.message;
                    conditionsToCheck.push({ condition, warningType: message });
                }
            }
        }

        console.log(conditionsToCheck);

        conditionsToCheck.forEach(({ condition, warningType }) => {
            handleWarning(props, warningMessages, setWarningMessages, condition, warningType);
        });
    }, [props.job]);
};

export default DesignerDrawingWarnings;
